import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctValue } from '../../../../Fct/generics';
import { ROUTER_ADDRESSES } from '../constants';
export var GetAmountsIn = createPlugin({
    protocol: 'SUSHISWAP',
    type: 'GETTER',
    method: 'getAmountsIn',
    supportedContracts: ROUTER_ADDRESSES,
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'uniswap_router' }),
            methodParams: {
                amountOut: new FctValue({}),
                path: new FctAddressList({}),
            },
        },
        output: {
            amountIn: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
            amountOut: new FctValue({ destination: 'wei_amount', innerIndex: -1 }),
        },
    }); },
});
